import * as React from 'react';
import {Card, Grid} from '@mui/material';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import {BarChart} from '@mui/x-charts';
import {Unstable_RadarChart as RadarChart} from '@mui/x-charts/RadarChart';
import {useMemo} from "react";
import {XYVO} from "@/service/analyze";
import {useAllDict} from "@/store/dict.c";
import {DictPO} from "@/model/system";
import {BarSeriesType} from "@mui/x-charts/models/seriesType/bar";
import {transformMoney} from "@/helper/method";

export interface ArrivalMoneyDistProps {
    yearPayment: XYVO[]
    paymentMethods: XYVO[]
    loading: boolean
}

export default function ArrivalMoneyDist({yearPayment, paymentMethods, loading}: ArrivalMoneyDistProps) {
    const {paymentMethod} = useAllDict()
    const {xDatas, bSeries} = useMemo(() => {
        const groupYearPayment = Object.groupBy(yearPayment, ({x}) => x);
        const yDatas: { [key: string]: number[] } = {};
        const xDatas: string[] = []

        Object.keys(groupYearPayment).forEach((key) => {
            const datas = groupYearPayment[key];
            xDatas.push(key);
            paymentMethod.forEach((method: DictPO) => {
                const list: number[] = yDatas[method.label] || []
                const data = datas?.find((item) => method.label == item.y2);
                if (data) {
                    list.push(Math.floor(data.y1));
                } else {
                    list.push(0);
                }
                yDatas[method.label] = list

            });
        });
        const bSeries: BarSeriesType[] = []
        Object.keys(yDatas).forEach((key) => {
            const data: number[] = yDatas[key] || []
            bSeries.push({data, valueFormatter: value => transformMoney(value), label: key, id: key, stack: 'total', type: 'bar'})
        })
        return {bSeries, xDatas}
    }, [yearPayment]);
    return (
        <Card variant="outlined" sx={{width: '100%'}}>
            <CardContent>
                <Grid container justifyContent={'space-between'} spacing={3}>
                    {/*<Grid size={5}>*/}
                    {/*    <Typography component="h2" variant="subtitle2" gutterBottom>*/}
                    {/*        付款方式分布*/}
                    {/*    </Typography>*/}
                    {/*    <RadarChart*/}
                    {/*        height={180}*/}
                    {/*        loading={loading}*/}
                    {/*        localeText={{loading: "加载中"}}*/}
                    {/*        margin={{top: 10, bottom: 10}}*/}
                    {/*        hideLegend={true}*/}
                    {/*        highlight={'none'}*/}
                    {/*        series={[{label: '金额', id: "money", valueFormatter: (value: number) => transformMoney(value), data: paymentMethods?.map(item => item.y1) || [],}, {*/}
                    {/*            label: '次数', id: 'amount',*/}
                    {/*            data: paymentMethods?.map(item => item.y2) || []*/}
                    {/*        }]}*/}
                    {/*        radar={{*/}
                    {/*            max: 120,*/}
                    {/*            metrics: paymentMethods?.map(item => item.x) || [],*/}
                    {/*        }}*/}
                    {/*    />*/}
                    {/*</Grid>*/}
                    <Grid size={12}>
                        <Typography component="h2" variant="subtitle2" gutterBottom>
                            近一年付款方式占比
                        </Typography>
                        <BarChart
                            // width={200}
                            height={180}
                            margin={{left: 0, right: 0, top: 10, bottom: 0}}
                            hideLegend={true}
                            series={bSeries}
                            loading={loading}
                            localeText={{loading: "加载中"}}
                            xAxis={[{
                                categoryGapRatio: 0.4,
                                tickInterval: (value: number, index: number) => index % 4 == 0,
                                data: xDatas, disableTicks: true,
                            }]}
                            yAxis={[{width: 40, valueFormatter: (value: number) => transformMoney(value), disableLine: true, disableTicks: true, position: 'right'}]}
                        />
                    </Grid>

                </Grid>
            </CardContent>
        </Card>
    );
}
